import { useAuthContext } from '../context/auth';

export const useClientId = (): string => {
  const { userInfo } = useAuthContext();
  return userInfo?.['custom:clientId'] || 'TEST';
};
